/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import Footer from "./footer";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  { id: 0, value: { priceNoVat: 0, priceVat: 0, vat: 0 } },
  { id: 1, value: { priceNoVat: 0, priceVat: 0, vat: 0 } },
  { id: 2, value: { priceNoVat: 0, priceVat: 0, vat: 0 } },
];

const dataTableB = [
  {
    id: 1,
    value: {
      shd: "",
      nhd: "",
      tcdt: "",
      mstcdt: "",
      tp: "",
      quan: "",
      phuong: "",
      soNha: "",
      tgthd: 0,
    },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);
  const [dataB, setDataB] = useState(dataTableB);

  useEffect(() => {
    setFieldValue("valuesTable", data);
    setFieldValue("valuesTableB", dataB);
  }, [data, dataB]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  const handleChangeB = (values) => {
    const { id, name, value } = values;
    setDataB((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(dataB);
  };

  const addNewRow = () => {
    const newIdValue = dataB.length + 1;
    const newRow = {
      id: newIdValue,
      value: {
        shd: "",
        nhd: "",
        tcdt: "",
        mstcdt: "",
        tp: "",
        quan: "",
        phuong: "",
        soNha: "",
        tgthd: 0,
      },
    };
    setDataB((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (dataB.length !== 1) {
      dataB.pop();
      const newRow = dataB;
      setDataB([...newRow]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-start">
        <Typography fontWeight="bold" variant="h6" fontSize={14}>
          I. Kê khai nghĩa vụ thuế:
        </Typography>
      </Box>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center", width: "5%" }}>STT</Th>
              <Th style={{ textAlign: "center", width: "35%" }}>Hoạt động</Th>
              <Th style={{ textAlign: "center", width: "20%" }}>
                Doanh thu chưa có thuế giá trị gia tăng [21]
              </Th>
              <Th style={{ textAlign: "center", width: "20%" }}>
                Tỷ lệ (%) thuế giá trị gia tăng [22]
              </Th>
              <Th style={{ textAlign: "center", width: "20%" }}>
                Thuế giá trị gia tăng phải nộp [23]=[21]x[22]
              </Th>
            </tr>
          </thead>
          <tbody>
            <tr key={0}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"1"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Hoạt động xây dựng"}
              </Td>

              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={0}
                  name="priceNoVat"
                  value={data[0].value.priceNoVat}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={0}
                  name="priceVat"
                  readonly="true"
                  value={data[0].value.priceVat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={0}
                  name="vat"
                  readonly="true"
                  value={data[0].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={1}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"2"}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"Hoạt động chuyển nhượng bất động sản"}
              </Td>

              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                }}
              >
                <InputTable
                  id={1}
                  name="priceNoVat"
                  value={data[1].value.priceNoVat}
                  onChange={handleChange}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={1}
                  name="priceVat"
                  readonly="true"
                  value={data[1].value.priceVat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={1}
                  name="vat"
                  readonly="true"
                  value={data[1].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
            <tr key={3}>
              <Td
                colSpan={2}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {"Tổng cộng "}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={2}
                  name="priceNoVat"
                  readonly="true"
                  value={data[2].value.priceNoVat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                {/* <InputTable
                  id={2}
                  name="priceVat"
                  value={data[2].value.priceVat}
                  onChange={handleChange}
                /> */}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                  fontWeight: "bold",
                }}
              >
                <InputTable
                  id={2}
                  name="vat"
                  readonly="true"
                  value={data[2].value.vat}
                  onChange={handleChange}
                  fontWeight={true}
                />
              </Td>
            </tr>
          </tbody>
        </table>
        <Box display="flex" justifyContent="flex-start" marginTop={2}>
          <Typography fontWeight="bold" variant="h6" fontSize={14}>
            II. Kê khai thông tin của hợp đồng xây dựng:
          </Typography>
        </Box>
        <Box>
          <table style={tableStyle}>
            <thead>
              <tr>
                <Th style={{ textAlign: "center", minWidth: 20 }} rowSpan={2}>
                  STT
                </Th>
                <Th style={{ textAlign: "center", minWidth: 150 }} rowSpan={2}>
                  Số hợp đồng
                </Th>
                <Th style={{ textAlign: "center", minWidth: 150 }} rowSpan={2}>
                  Ngày hợp đồng
                </Th>
                <Th style={{ textAlign: "center", minWidth: 200 }} rowSpan={2}>
                  Tên chủ đầu tư
                </Th>
                <Th style={{ textAlign: "center", minWidth: 200 }} rowSpan={2}>
                  Mã số thuế của chủ đầu tư (nếu có)
                </Th>
                <Th style={{ textAlign: "center" }} colSpan={4}>
                  Địa chỉ nơi có công trình
                </Th>
                <Th style={{ textAlign: "center", minWidth: 200 }} rowSpan={2}>
                  Tổng giá trị hợp đồng (chưa có thuế GTGT)
                </Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>Tỉnh/TP</Th>
                <Th style={{ textAlign: "center" }}>Quận/Huyện</Th>
                <Th style={{ textAlign: "center" }}>Phường/Xã</Th>
                <Th style={{ textAlign: "center", minWidth: 200 }}>Số nhà, đường phố</Th>
              </tr>
            </thead>
            <tbody>
              {dataB &&
                dataB.length > 0 &&
                dataB.map((rows) => (
                  <tr key={rows.id}>
                    <Td
                      style={{
                        textAlign: "center",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      {rows.id}
                    </Td>
                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "left",
                        background: "transparent",
                        fontWeight: 400,
                      }}
                    >
                      <InputTable2
                        id={rows.id}
                        name="shd"
                        value={rows.value.shd}
                        onChange={handleChangeB}
                      />
                    </Td>

                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: "transparent",
                      }}
                    >
                      <InputTable2
                        type={"date"}
                        id={rows.id}
                        name="nhd"
                        value={rows.value.nhd}
                        onChange={handleChangeB}
                      />
                    </Td>

                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: "transparent",
                      }}
                    >
                      <InputTable2
                        id={rows.id}
                        name="tcdt"
                        value={rows.value.tcdt}
                        onChange={handleChangeB}
                      />
                    </Td>

                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: "transparent",
                      }}
                    >
                      <InputTable2
                        id={rows.id}
                        name="mstcdt"
                        value={rows.value.mstcdt}
                        onChange={handleChangeB}
                      />
                    </Td>

                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: "transparent",
                      }}
                    >
                      <InputTable2
                        id={rows.id}
                        name="tp"
                        value={rows.value.tp}
                        onChange={handleChangeB}
                      />
                    </Td>

                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: "transparent",
                      }}
                    >
                      <InputTable2
                        id={rows.id}
                        name="quan"
                        value={rows.value.quan}
                        onChange={handleChangeB}
                      />
                    </Td>

                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: "transparent",
                      }}
                    >
                      <InputTable2
                        id={rows.id}
                        name="phuong"
                        value={rows.value.phuong}
                        onChange={handleChangeB}
                      />
                    </Td>

                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: "transparent",
                      }}
                    >
                      <InputTable2
                        id={rows.id}
                        name="soNha"
                        value={rows.value.soNha}
                        onChange={handleChangeB}
                        type="decimal"
                      />
                    </Td>

                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "right",
                        background: "transparent",
                      }}
                    >
                      <InputTable
                        id={rows.id}
                        name="tgthd"
                        value={rows.value.tgthd}
                        onChange={handleChangeB}
                      />
                    </Td>
                  </tr>
                ))}
            </tbody>
          </table>
        </Box>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
